import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { TbFaceIdError } from 'react-icons/tb';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { TiArrowLoopOutline } from 'react-icons/ti';
import { HiDocumentReport } from 'react-icons/hi';
import { MdOutlineProductionQuantityLimits } from 'react-icons/md';

const tiles = [
  {
    sNo: 1,
    link: '/common/masterListOfProblemOrDefects',
    isLink: true,
    icon: <TbFaceIdError size="5rem" color="#a12222" />,
    p: 'List Of Problem ',
    span: '/ Defects',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/production/dept/scrapnote',
    isLink: true,
    icon: <RiDeleteBin4Fill size="5rem" color="#a12222" />,
    p: 'Scrap Note',
    span: '',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/production/dept/reworkrecord',
    isLink: true,
    icon: <TiArrowLoopOutline size="5rem" color="#a12222" />,
    p: 'Rework Record',
    span: '',
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/dailyProductionRecordList',
    isLink: true,
    icon: <MdOutlineProductionQuantityLimits size="5rem" color="#003566" />,
    p: 'Daily Production',
    span: 'Record',
    isIcon: true,
  },
];

const Home = () => {
  return (
    <>
      <ChildHeader text="Production Department" />
      <RenderTiles
        height="100%"
        tilesObj={tiles}
        justify="start"
        columns="0fr"
      />
    </>
  );
};

export default Home;
